// @ts-nocheck
import React from "react";
import ButtonSelectionDataSourceForm from "./ButtonSelectionDataSourceForm";

const ExploreDataSourceForm = ({
  selectedAsset,
  onSubmitForm,
  onChange,
  dataSourceRecord,
  dataSourceRecordId,
  onDataSourceChange,
  onCancel,
  initialStep,
}) => {
  if (!dataSourceRecord) {
    console.log("Data source record doesn't exist");
    return false;
  }
  
  console.log("ExploreDataSourceForm - initialStep:", initialStep);
  
  return (
    <div className="flex flex-col">
      <ButtonSelectionDataSourceForm 
        selectedAsset={selectedAsset}
        onSubmitForm={onSubmitForm}
        dataSourceRecord={dataSourceRecord}
        onDataSourceChange={onDataSourceChange}
        onCancel={onCancel}
        initialStep={initialStep}
      />
    </div>
  );
};

export default ExploreDataSourceForm;
